export const getStringWithMask = (string: string | undefined = "", numberOfLetters: number) => {
    let stringWithMask = "";
    if (string.length === numberOfLetters) {
        return string;
    }
    for (let i = 0; i < numberOfLetters; i++) {
        stringWithMask = stringWithMask + (string[i] || "_");
    }
    return stringWithMask;
};

export const getFormattedCPF = (value: string) => {
    const blocks = value.match(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/);
    return `${getStringWithMask(blocks?.[1], 3)}.${getStringWithMask(
        blocks?.[2],
        3,
    )}.${getStringWithMask(blocks?.[3], 3)}-${getStringWithMask(blocks?.[4], 2)}`;
};
